import axios from "axios";

export const state = {
    subscriptionfees: [],
};

export const getters = {
    subscriptionfees: state => state.subscriptionfees,
};

export const mutations = {
    setSubscriptionFees(state, newValue) {
        state.subscriptionfees = newValue
    },
};

export const actions = {
    async fetchSubscriptionFees({ commit }) {
        await axios.get('/subscriptionfees').then(res => {
            commit('setSubscriptionFees', res.data.subscriptionfees)
        })
    },
    async filterSubscriptionFees({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filtersubscriptionfees";
        await axios.post(url, formData).then((response) => {
            commit('setSubscriptionFees', response.data.subscriptionfees)
        })
    },
};
